export default {
  title: 'Noticias',
  createPost: 'Crear Publicación',
  titleLabel: 'Título',
  contentLabel: 'Contenido',
  viewerLabel: 'Visualizador',
  customizerLabel: 'Personalizador',
  managerLabel: 'Administrador',
  close: 'Cerrar',
  save: 'Guardar',
  headerTitle: 'Título',
  headerContent: 'Contenido',
  headerProfiles: 'Perfiles',
  headerCreator: 'Creador',
  headerCreated: 'Creado',
  headerActions: 'Acciones',
  noData: 'Sin datos',
  deleteConfirm: '¿Estás seguro de que deseas eliminar esta publicación?',
  notAvailable: 'N/D'
}
